import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconBuster(props: SvgIconProps) {
  return (
    <SVGIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1" y="1" width="18" height="18" rx="9" stroke="currentColor" strokeWidth="2" />
      <path d="M4 16L16 4" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
